/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFDomainsEmailRecord } from './CRSFDomainsEmailRecord';
import {
    CRSFDomainsEmailRecordFromJSON,
    CRSFDomainsEmailRecordFromJSONTyped,
    CRSFDomainsEmailRecordToJSON,
} from './CRSFDomainsEmailRecord';

/**
 * 
 * @export
 * @interface CRSFDomainsEmail
 */
export interface CRSFDomainsEmail {
    /**
     * 
     * @type {CRSFDomainsEmailRecord}
     * @memberof CRSFDomainsEmail
     */
    dmarc: CRSFDomainsEmailRecord;
    /**
     * 
     * @type {CRSFDomainsEmailRecord}
     * @memberof CRSFDomainsEmail
     */
    spf: CRSFDomainsEmailRecord;
    /**
     * 
     * @type {number}
     * @memberof CRSFDomainsEmail
     */
    total: number;
    /**
     * 
     * @type {CRSFDomainsEmailRecord}
     * @memberof CRSFDomainsEmail
     */
    without_dmarc: CRSFDomainsEmailRecord;
    /**
     * 
     * @type {CRSFDomainsEmailRecord}
     * @memberof CRSFDomainsEmail
     */
    without_spf: CRSFDomainsEmailRecord;
}

/**
 * Check if a given object implements the CRSFDomainsEmail interface.
 */
export function instanceOfCRSFDomainsEmail(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "dmarc" in value;
    isInstance = isInstance && "spf" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "without_dmarc" in value;
    isInstance = isInstance && "without_spf" in value;

    return isInstance;
}

export function CRSFDomainsEmailFromJSON(json: any): CRSFDomainsEmail {
    return CRSFDomainsEmailFromJSONTyped(json, false);
}

export function CRSFDomainsEmailFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFDomainsEmail {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dmarc': CRSFDomainsEmailRecordFromJSON(json['dmarc']),
        'spf': CRSFDomainsEmailRecordFromJSON(json['spf']),
        'total': json['total'],
        'without_dmarc': CRSFDomainsEmailRecordFromJSON(json['without_dmarc']),
        'without_spf': CRSFDomainsEmailRecordFromJSON(json['without_spf']),
    };
}

export function CRSFDomainsEmailToJSON(value?: CRSFDomainsEmail | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dmarc': CRSFDomainsEmailRecordToJSON(value.dmarc),
        'spf': CRSFDomainsEmailRecordToJSON(value.spf),
        'total': value.total,
        'without_dmarc': CRSFDomainsEmailRecordToJSON(value.without_dmarc),
        'without_spf': CRSFDomainsEmailRecordToJSON(value.without_spf),
    };
}

